module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("placed my name on the list for a visit to an English school. Perhaps pleased that this time my means of travel would be safer, my parents agreed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("We left Rotterdam one fine summer evening on a battered wartime freighter, a Liberty ship going to London. We sat on the deck as the ship sailed into the setting sun, exactly as I had seen in one the very occasional films we saw. There were guitars and we sang all night, arriving the following morning, bleary-eyed but happy, at the docks of East London. There were represent- atives of the WFA on shore and they called one group after another, to be assigned to their hosts. It became late in the day, our group was last. There was only one representative left on the quay, a thin, dark young man who had some kind of secretarial position in the WFA. The captain of the Liberty ship wanted to leave, the freighter had to be back in Rotterdam – were we getting off his boat or not? The thin young man made a decision: the last group would go ashore. He would take us to his home, and sort it out from there.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("We arrived at his place, which was a large, comfortable apartment that featured a big grand piano. The young man introduced us to his father, and then went out with our teacher to find a place for us to sleep that night. The father scratched his head – what was he to do with us? He asked us to sit on the floor and said that all he could do for us was to play on his grand piano; would we like that? We were a rowdy bunch of boys but when he started playing, we fell silent. For a long time we sat still on the floor, listening to the most enchanting music that we had ever heard. Later that evening, when his son and our teacher came back saying that they had found accommodation, we thanked our host politely and filed out. It was not until much later that I found out who Arthur Rubinstein was.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The accommodation that the WFA had found for us was in a war-time air raid shelter located in a disused tunnel of the Underground, part of a network of old tunnels. We slept on hard bunks under crude blankets but we were fed and soon found our way around the network of tunnels. We lived there for three days, running here and there, popping up in Hyde Park or Marble Arch, and wherever we could find our way around the official system of entries and exits. Although we had a whale of a time, the newspapers got hold of the story. The next morning, scandal headlines proclaimed that poor Dutch children were locked up in underground tunnels like rats.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("It worked; we were adopted by a school in Brighton. As the train going south went through a bend I looked out of the window. North of us a dome of black cloud lay on the horizon. I said to an Englishman that a storm was coming but he said that what I saw was the air over London. It was the first time I saw smog. My first encounter with air pollution scared me as much then as it does now.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("At the platform in Brighton we were received by a whole gaggle of girls in blazers; I thought they were Girl Guides but I was wrong – I had not seen school uniforms before. The girls were from an exclusive school for girls only, which was also strange to us. We were taken to the institution and, as it was a")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afe31f56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0044.vue
// module id = 192
// module chunks = 0